
import { Separator } from "@/components/ui/separator";

const CookiePolicy = () => {
  return (
    <div className="max-w-4xl mx-auto font-poppins-regular">
      <h1 className="text-3xl font-poppins-bold mb-6">Cookie Szabályzat</h1>
      <Separator className="mb-8" />
      
      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">1. Mi az a cookie?</h2>
        <p className="text-gray-700 mb-4">
          A cookie-k (sütik) kis szöveges fájlok, amelyeket a webhelyek a felhasználó eszközén tárolnak, hogy emlékezzenek a felhasználói beállításokra és preferenciákra, valamint statisztikai adatokat gyűjtsenek a webhelyek használatáról.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-poppins-semibold mb-4">2. Milyen cookie-kat használunk?</h2>
        <p className="text-gray-700 mb-4">
          Weboldalunkon a következő típusú cookie-kat használjuk:
        </p>
        
        <h3 className="text-lg font-poppins-medium mt-4 mb-2">Szükséges cookie-k</h3>
        <p className="text-gray-700 mb-4">
          Ezek a cookie-k elengedhetetlenek a weboldal megfelelő működéséhez. Ide tartoznak például a bejelentkezéshez, a vásárlókosár kezeléséhez és a biztonsági funkciókhoz szükséges cookie-k.
        </p>
        
        <h3 className="text-lg font-poppins-medium mt-4 mb-2">Preferencia cookie-k</h3>
        <p className="text-gray-700 mb-4">
          Ezek a cookie-k lehetővé teszik, hogy a weboldal emlékezzen a felhasználói preferenciákra, például a nyelvi beállításokra, a megjelenítési beállításokra vagy a regisztrált felhasználónévre.
        </p>
        
        <h3 className="text-lg font-poppins-medium mt-4 mb-2">Statisztikai cookie-k (Google Analytics)</h3>
        <p className="text-gray-700 mb-4">
          Oldalunk a Google Analytics szolgáltatást használja a látogatói adatok gyűjtésére. Ezek a cookie-k segítenek megérteni, hogyan használják a látogatók a weboldalt. Anonim módon gyűjtenek információkat például arról, hogy mely oldalakat látogatják a felhasználók leggyakrabban, illetve hogy találnak-e hibákat a webhelyen. Az ezekből nyert adatok segítenek nekünk fejleszteni a weboldalt és a felhasználói élményt.
        </p>
        
        <h3 className="text-lg font-poppins-medium mt-4 mb-2">Marketing cookie-k</h3>
        <p className="text-gray-700 mb-4">
          Ezeket a cookie-kat a releváns és személyre szabott marketing tartalmak megjelenítéséhez használjuk. Segítenek mérni a marketing kampányok hatékonyságát is.
        </p>
        
        <h3 className="text-lg font-poppins-medium mt-4 mb-2">Google Tag Manager</h3>
        <p className="text-gray-700 mb-4">
          A Google Tag Manager segítségével kezeljük a weboldalunkon használt különböző kódokat és szkripteket. Ez a szolgáltatás önmagában nem használ cookie-kat a látogatók adatainak tárolására, de segít a különböző marketing és analitikai eszközök telepítésében és kezelésében. A Tag Manager segítségével pontosabb és átláthatóbb adatokat kaphatunk az oldal használatáról.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">3. Cookie-k kezelése</h2>
        <p className="text-gray-700 mb-4">
          A legtöbb webböngésző lehetővé teszi a cookie-k kezelését a beállításokon keresztül. Letilthatja az új cookie-k elfogadását, vagy törölheti a meglévőket. Kérjük, vegye figyelembe, hogy a cookie-k letiltása befolyásolhatja a weboldal funkcionalitását.
        </p>
        <p className="text-gray-700 mb-4">
          A cookie-k kezeléséről a böngészője súgójában talál további információkat:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-medihub-primary hover:underline">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/hu/kb/sutik-engedelyezese-es-tiltasa" target="_blank" rel="noopener noreferrer" className="text-medihub-primary hover:underline">Mozilla Firefox</a></li>
          <li><a href="https://support.microsoft.com/hu-hu/windows/microsoft-edge-böngészési-adatok-és-adatvédelem-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd" target="_blank" rel="noopener noreferrer" className="text-medihub-primary hover:underline">Microsoft Edge</a></li>
          <li><a href="https://support.apple.com/hu-hu/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-medihub-primary hover:underline">Safari</a></li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">4. Google Analytics és a Google Tag Manager használata</h2>
        <p className="text-gray-700 mb-4">
          Weboldalunk használja a Google Analytics és a Google Tag Manager szolgáltatásokat. Ezek a szolgáltatások segítenek megérteni, hogyan használják a látogatók a weboldalt, és hogyan javíthatjuk a felhasználói élményt.
        </p>
        <p className="text-gray-700 mb-4">
          A Google Analytics által gyűjtött adatok közé tartozik:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>A weboldalon töltött idő</li>
          <li>A meglátogatott oldalak</li>
          <li>A látogatók földrajzi elhelyezkedése</li>
          <li>A weboldal elérésének forrása</li>
          <li>A használt eszközök (asztali számítógép, mobil, tablet)</li>
        </ul>
        <p className="text-gray-700 mb-4">
          Az összes összegyűjtött adat anonim, és nem használható fel a felhasználók személyes azonosítására. A Google Analytics által gyűjtött adatok kezeléséről további információkat találhat a <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-medihub-primary hover:underline">Google adatvédelmi irányelvei</a> oldalon.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-4">5. Cookie-k élettartama</h2>
        <p className="text-gray-700 mb-4">
          A cookie-k élettartama változó:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>Munkamenet cookie-k: Ezek ideiglenes cookie-k, amelyek a böngésző bezárásakor törlődnek.</li>
          <li>Állandó cookie-k: Ezek a cookie-k a böngésző bezárása után is a felhasználó eszközén maradnak, amíg le nem járnak vagy a felhasználó nem törli őket.</li>
        </ul>
      </section>
      
      <div className="mt-8 text-sm text-gray-500">
        <p>Utolsó frissítés: 2024. július 10.</p>
      </div>
    </div>
  );
};

export default CookiePolicy;
